import React, { useState } from 'react'
import PropTypes from 'prop-types'
import AsyncSelect from 'react-select/async'
import School from '../../../models/School'
import District from '../../../models/District'
import Select from "react-select";

const SchoolAsyncSelect = ({ name, placeholder, jotformUrl }) => {
  const [school, setSchool] = useState()
  const [district, setDistrict] = useState()
  const [schoolEmployee, setSchoolEmployee] = React.useState("");
  const [email, setEmail] = useState("");

  const changeHandler = (opt) => {
    setSchool(opt)
  }

  const changeDistrictHandler = (opt) => {
    setDistrict(opt)
    setSchool()
  }

  const changeSchoolEmployee = (opt) => {
    setSchoolEmployee(opt)
  }

  const options = [
    { value: "None", label: "None" },
    { value: "Principal", label: "Principal" },
    { value: "Vice-Principal", label: "Vice-Principal" },
    { value: "Office Manager", label: "Office Manager" },
    { value: "Secretary", label: "Secretary" },
    { value: "Teacher", label: "Teacher" },
    { value: "Educational Support", label: "Educational Support" }
  ];

  const formatUrl = () => {
    if (!school) return '';
    const url = new URL(jotformUrl);

    url.searchParams.append('schoolId', school.value);
    url.searchParams.append('districtId', district.value);
    url.searchParams.append('schoolName', school.data.name);
    url.searchParams.append('districtName', district.data.name);
    url.searchParams.append('city', school.data.cityName);
    url.searchParams.append('school_employee', schoolEmployee.value);
    if (email) url.searchParams.append('email', email);

    return url
  }

  const loadSchoolOptionsQuery = () => (value, callback) => {
    School
      .where({
        district_id: district.data.id,
        name: { match: value },
      })
      .order({ name: 'asc' })
      .per(50)
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.cityName ? `${e.name} (${e.cityName})` : e.name, value: e.id, data: e }))
        callback(options)
      })
  }

  const loadDistrictOptionsQuery = () => (value, callback) => {
    District
      .where({
        name: { match: value }
      })
      .order({ name: 'asc' })
      .per(50)
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.name, value: e.id, data: e }))
        callback(options)
      })
  }

  return (
    <>
      <AsyncSelect
        cacheOptions
        defaultOptions
        placeholder="Type   the   3 letters your School District starts with"
        defaultValue={district}
        name="district"
        loadOptions={loadDistrictOptionsQuery()}
        onChange={changeDistrictHandler}
      />

      <br/>

      {district && (
        <AsyncSelect
          cacheOptions
          defaultOptions
          placeholder={placeholder}
          defaultValue={school}
          name={name}
          key={district.value}
          loadOptions={loadSchoolOptionsQuery()}
          onChange={changeHandler}
        />
        
      )}
      <br/>
       {school && (   
        <Select
          options={options}
          onChange={(e) => changeSchoolEmployee(e)}
          value={schoolEmployee}
          label="Single select"
          placeholder={"Select your position"}
          menuPlacement="top"
          required
        />
        )}
        

      {schoolEmployee && (schoolEmployee.value === 'Teacher' || schoolEmployee.value === 'Educational Support') && (
        <>
          <br/>
          <input
            type="email"
            className="form-control"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ maxWidth: 400 }}
          />
        </>
      )}

      <br/>

      {schoolEmployee && school && (
        (schoolEmployee.value === 'Teacher' || schoolEmployee.value === 'Educational Support') ? (
          email && (
            <a href={formatUrl()}
               target="_blank" className="btn btn-primary">
              Continue
            </a>
          )
        ) : (
          <a href={formatUrl()}
             target="_blank" className="btn btn-primary">
            Continue
          </a>
        )
      )}
    </>
  )
}

SchoolAsyncSelect.propTypes = {
  name: PropTypes.string,
  selectedValue: PropTypes.object,
  valueField: PropTypes.string,
  extraFields: PropTypes.array,
  placeholder: PropTypes.string,
}

SchoolAsyncSelect.defaultProps = {
  name: null,
  selectedValue: null,
  valueField: 'name',
  extraFields: [],
  placeholder: 'Search',
}

export default SchoolAsyncSelect
